<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button (click)="cancel()" aria-label="Close" class="btn-close" type="button"></button>
</div>
<form (keydown.enter)="$event.preventDefault()" (submit)="submitForm($event)" [formGroup]="detailForm">
  <div class="modal-body">

    <div class="row">
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="zip-code-input">Zip Code<span class="required">*</span></label>
          <input class="form-control" formControlName="zipcode" id="zip-code-input" placeholder="Enter your Zip Code"
                 type="text">
        </div>
        <dp-field-error [formField]="form['zipcode']"></dp-field-error>
      </div>
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="status-input">Partner<span class="required">*</span></label>
          <div>
            <ng-select [items]="zipCodeOptions"
                       [multiple]="false"
                       bindLabel="name"
                       bindValue="code"
                       class="form-control"
                       formControlName="partner"
                       id="status-input"
                       placeholder="Select Partner">
            </ng-select>
          </div>
        </div>
        <dp-field-error [formField]="form['partner']"></dp-field-error>
      </div>
    </div>

  </div>

</form>
<div *ngIf="!showOnboarding" class="modal-footer">
  <button (click)="submitForm($event)" class="btn btn-dark button-large" type="submit">{{ saveButtonLabel }}</button>
</div>
